import HttpCliente from "../HttpCliente";

// Obtener todos los horarios de clientes
export const getHorariosClientes = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/HorarioCliente/ObtenerHorarios", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Obtener horarios agrupados
export const getHorariosClientesAgrupados = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/HorarioCliente/ObtenerHorariosClientes", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Crear nuevo horario para cliente
export const crearHorarioCliente = (token, horarioCliente) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/HorarioCliente/Crear", horarioCliente, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Modificar horario de cliente
export const editarHorarioCliente = (token, horarioCliente) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/HorarioCliente/EditarHorario", horarioCliente, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Obtener horario por id de cliente
export const getHorarioCliente = (token, clienteId) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/HorarioCliente/ObtenerHorarioCliente/${clienteId}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Eliminar horarios de un cliente
export const eliminarHorariosCliente = (token, clienteId) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/HorarioCliente/Eliminar/${clienteId}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const eliminarHorariosEspecificos = (token, horarioIds) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete("/HorarioCliente/EliminarHorariosEspecificos", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      data: horarioIds // Los IDs van en el body para DELETE
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};